import { dataShieldTimesSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconShieldTimesSolid = /*#__PURE__*/createIcon(dataShieldTimesSolid)
export default IconShieldTimesSolid
